export const BodyprintQueueStatus = Object.freeze({
  COMPLETED: "COMPLETED",
  COMPLETED_IN_PROGRESS: "COMPLETED_IN_PROGRESS",
  COMPLETED_IN_REVIEW: "COMPLETED_IN_REVIEW",
  INCOMPLETE: "INCOMPLETE",
  IN_PROGRESS: "IN_PROGRESS",
  IN_REVIEW: "IN_REVIEW",
  ARCHIVED_BY_USER: "ARCHIVED_BY_USER",
  ARCHIVED_BY_RETAILER: "ARCHIVED_BY_RETAILER",
  REJECTED: "REJECTED"
});
